module.exports = __webpack_public_path__ + "static/img/shop_img01.6a87708.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/integralshop/shop_img01.png
// module id = fFYP
// module chunks = 174